import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { FnPipe } from '@shared/pipes/fn.pipe';
import { TableCellDirective } from '@shared/directives/table-cell.directive';
import { EmptyPageComponent } from '@shared/components/placeholder/empty-page/empty-page.component';
import { IterablePipe } from '@shared/pipes/iterable.pipe';
import { InfoSectionComponent } from '@shared/components/placeholder/info-section/info-section.component';
import { SectionSideNavComponent } from '@shared/components/side-nav/section-side-nav/section-side-nav.component';
import { TemplateHostDirective } from '@shared/directives/template-host.directive';
import { SectionContentComponent } from '@shared/components/side-nav/section-content/section-content.component';
import { LoaderComponent } from './components/loader/loader.component';
import { LoaderDirective } from './directives/loader.directive';
import { TypeItemComponent } from '@shared/components/type-item/type-item.component';
import { StageItemComponent } from '@shared/components/stage-item/stage-item.component';
import { SelectComponent } from '@shared/components/popup/select/select.component';
import { GradientIconViewComponent } from '@shared/components/gradient-icon-view/gradient-icon-view.component';
import { SwipeableDirective } from '@shared/components/swipe-stack/swipe-card-wrapper/swipeable.directive';
import { SwipeCardWrapperComponent } from '@shared/components/swipe-stack/swipe-card-wrapper/swipe-card-wrapper.component';
import { BorderedIconButtonComponent } from '@shared/components/bordered-icon-button/bordered-icon-button.component';
import { MatchItemComponent } from './components/match-item/match-item.component';
import { MascotDialogComponent } from './components/mascot-dialog/mascot-dialog.component';
import { StoryGuideComponent } from '@shared/components/story-guide/story-guide.component';
import { MatButtonLoadingDirective } from '@shared/directives/mat-button-loading.directive';
import { SafePipe } from './pipes/safe.pipe';
import { SelectableDirective } from './directives/selectable.directive';
import { JobTypeToValuePipe } from '@shared/pipes/job-type-to-value.pipe';
import { CarouselComponent } from './components/carousel/carousel.component';
import { CarouselItemDirective } from '@shared/components/carousel/carousel.directive';
import { UrlPipe } from './pipes/url.pipe';
import { LocationSelectorComponent } from '@shared/components/location-selector/location-selector.component';
import { InputDialogComponent } from '@shared/components/dialog/input-dialog/input-dialog.component';
import { LanguageSelectComponent } from './components/language-select/language-select.component';
import { DownloadRoadmapDirective } from './directives/download-roadmap.directive';
import { LocalizedPipe } from './pipes/localized.pipe';
import { MarkdownPipe } from './pipes/markdown.pipe';
import { ListToStringPipe } from './pipes/list-to-string.pipe';
import { MapPipe } from './pipes/map.pipe';
import { DetectOverflowDirective } from './directives/detect-overflow.directive';
import { AutofocusDirective } from './directives/autofocus.directive';
import { LabelledCircleProgressComponent } from '@shared/components/labelled-circle-progress/labelled-circle-progress.component';
import { InfoBoxComponent } from '@shared/components/info-box/info-box.component';
import { StickyBottomActionBarComponent } from '@shared/components/sticky-bottom-action-bar/sticky-bottom-action-bar.component';

/**
 * Re-export barrel for the standalone shared artifacts: `imports` mirrors `exports`
 * exactly (an NgModule must import a standalone artifact to re-export it). Nothing is
 * declared here. Long-term this module is slated for retirement in favor of direct
 * standalone imports.
 */
const SHARED_ARTIFACTS = [
  FnPipe,
  TableCellDirective,
  SectionSideNavComponent,
  LoaderComponent,
  StoryGuideComponent,
  LoaderDirective,
  TypeItemComponent,
  IterablePipe,
  SectionContentComponent,
  MatchItemComponent,
  EmptyPageComponent,
  InfoSectionComponent,
  MascotDialogComponent,
  GradientIconViewComponent,
  SwipeCardWrapperComponent,
  SwipeableDirective,
  BorderedIconButtonComponent,
  MatButtonLoadingDirective,
  SafePipe,
  SelectableDirective,
  JobTypeToValuePipe,
  CarouselComponent,
  CarouselItemDirective,
  UrlPipe,
  TemplateHostDirective,
  LocationSelectorComponent,
  SelectComponent,
  InputDialogComponent,
  LanguageSelectComponent,
  StageItemComponent,
  DownloadRoadmapDirective,
  LocalizedPipe,
  ListToStringPipe,
  MapPipe,
  DetectOverflowDirective,
  AutofocusDirective,
  MarkdownPipe,
  LabelledCircleProgressComponent,
  InfoBoxComponent,
  StickyBottomActionBarComponent,
];

@NgModule({
  imports: [CommonModule, TranslateModule, ...SHARED_ARTIFACTS],
  exports: [CommonModule, TranslateModule, ...SHARED_ARTIFACTS],
  providers: [{ provide: MAT_DATE_LOCALE, useValue: 'de-DE' }],
})
export class SharedModule {}
